import React, {useEffect, useState} from 'react';
import { isBrowser } from 'react-device-detect';
import { useSelector, useDispatch } from 'react-redux';
import CustomButton from '../../../../components/CustomButton';
import MediumModal from '../../../../components/modals/MediumModal';
import { closeOrderSafeCallModal } from '../../../../redux/actions/modals';
import { makeSafeCall } from '../../../../redux/actions/safeCall';

const SafeCallModal = () => {
    const dispatch = useDispatch();
    const [contactPhone, setContactPhone] = useState('');
    const {
        order_safe_call_open,
        order_safe_call_order,
    } = useSelector((state) => state.modals);
    const {
        make_safe_call_waiting
    } = useSelector((state) => state.safeCall);
    useEffect(() => {
        let contact_phone = localStorage.getItem('contact_phone');
        let username = JSON.parse(localStorage.getItem('user')).username;
        if(contact_phone !== null && contact_phone !== undefined){
            setContactPhone(contact_phone);
        }else{
            setContactPhone(username);
        }
    }, []);
    const startCall = () => {
        localStorage.setItem('contact_phone',contactPhone);
        let data = {
            orderId : order_safe_call_order.id,
            mobile : contactPhone
        };

        dispatch(makeSafeCall(data));
    };
    return (
        <>
            <MediumModal
                header=""
                show={order_safe_call_open}
                closeFunction={closeOrderSafeCallModal}
            >
                <div className={isBrowser ? "safe-call-form-holder" : "safe-call-form-holder-mobile"}>
                    <div className="form-holder">
                        <div className="form-group row">
                            <div className="col-lg-12">
                                {
                                    contactPhone !== '' ? 
                                    <div className="note">
                                        <span>تا چند لحظه دیگر با شماره</span>
                                        <span className="number">&nbsp;{contactPhone}&nbsp;</span>
                                        <span>تماس گرفته می‌شود و شما میتوانید با کاربر سفارش دهنده صحبت کنید.</span>
                                    </div>
                                    : ''
                                }
                            </div>
                            <div className="col-lg-12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="شماره تماس شما"
                                    value={contactPhone}
                                    onChange={(phone) => setContactPhone(phone.target.value)}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-sm-6">
                                <CustomButton 
                                    className="btn btn-small btn-success text-white full-width"
                                    action={startCall}
                                    content={"تماس بگیر"}
                                    block={true}
                                    type={'success'}
                                    loading={make_safe_call_waiting}
                                    textWhite={true}
                                />
                            </div>
                            <div className="col-sm-6">
                                <button
                                    className="btn btn-small btn-outline-black full-width"
                                    onClick={() => {
                                    dispatch(closeOrderSafeCallModal());
                                    }}
                                >
                                    انصراف
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </MediumModal>
        </>
    )
};

export default SafeCallModal;